export var DeviceType;
(function (DeviceType) {
    DeviceType["Desktop"] = "Desktop";
    DeviceType["Mobile"] = "Mobile";
    DeviceType["Tablet"] = "Tablet";
})(DeviceType || (DeviceType = {}));
//# sourceMappingURL=device-type.const.js.map